import { createSlice, createAsyncThunk, createSelector } from '@reduxjs/toolkit';

// import { fetchGetCampaignStatuses } from 'api/campaignApi'; // Removed - not needed in customer portal
import showSnackbarError from 'utils/showSnackbarError';

const initialState = {
  statuses: [],
  isLoaded: false,
  isLoading: false
};

// Removed - Status filters not used in customer portal
// export const getCampaignStatuses = createAsyncThunk(
//   'campaignStatuses/getCampaignStatuses',
//   async (_, { dispatch, rejectWithValue }) => {
//     try {
//       const statuses = await fetchGetCampaignStatuses();
//
//       return statuses;
//     } catch (e) {
//       dispatch(showSnackbarError(e.message, e.stack));
//
//       return rejectWithValue(e.response.data);
//     }
//   },
//   {
//     condition: (_, { getState }) => {
//       const { statuses, isLoading } = getState().campaignStatuses;
//
//       if (isLoading || statuses.length > 0) {
//         return false;
//       }
//
//       return true;
//     },
//   },
// );

const campaignStatusesSlice = createSlice({
  name: 'campaignStatuses',
  initialState,
  reducers: {}
  
  // extraReducers removed - getCampaignStatuses thunk is commented out
  // Status filters are not used in customer portal, so this slice is now minimal
  // extraReducers: (builder) => {
  //   builder
  //     .addCase(getCampaignStatuses.pending, (state) => {
  //       state.isLoading = true;
  //     })
  //     .addCase(getCampaignStatuses.fulfilled, (state, { payload }) => {
  //       state.statuses = payload;
  //       state.isLoading = false;
  //       state.isLoaded = true;
  //     })
  //     .addCase(getCampaignStatuses.rejected, (state) => {
  //       state.isLoading = false;
  //       state.isLoaded = true;
  //     });
  // }
});

const selectSelf = (state) => state.campaignStatuses;
const statuses = createSelector(selectSelf, (state) => state.statuses);
const isLoading = createSelector(selectSelf, (state) => state.isLoading);
const isLoaded = createSelector(selectSelf, (state) => state.isLoaded);

export const CampaignStatusesSelectors = {
  statuses,
  isLoading,
  isLoaded
};

export default campaignStatusesSlice.reducer;
